var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.5,
    height: 20,
    viewBox: "0 0 17.5 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-copy",
    "data-name": "Icon awesome-copy",
    d: "M12.5,17.5v1.563a.937.937,0,0,1-.937.938H.938A.937.937,0,0,1,0,19.063V4.688A.937.937,0,0,1,.938,3.75H3.75V15.313A2.19,2.19,0,0,0,5.938,17.5Zm0-13.437V0H5.938A.937.937,0,0,0,5,.938V15.313a.937.937,0,0,0,.938.937H16.563a.937.937,0,0,0,.938-.937V5H13.438A.94.94,0,0,1,12.5,4.063ZM17.225,2.85,14.65.275A.938.938,0,0,0,13.987,0H13.75V3.75H17.5V3.513a.937.937,0,0,0-.275-.663Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.5934b1f8ff320b0951c1fcb970401d4d.svg";
export { ForwardRef as ReactComponent };